module.exports = __webpack_public_path__ + "static/media/clip.c9ca5236.svg";